import { Guid } from 'guid-typescript';

import { Company } from './company';
import { UserType } from '~/v2/data/schema/userType';

export const ACTIVEMEMBER_STORAGE_KEY = 'activemember';

export class MemberIdentity {
  identifier: Guid = Guid.parse(Guid.EMPTY);
  companies: Company[] = [];
  userType: UserType = UserType.Unspecified;
  supplierContactId: string | null = '';
  customerContactId = '';
  professionalId: string | null = '';
  isActive = false;
}
